module.exports = __webpack_public_path__ + "static/media/Integrity.032688fc.jpg";